var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"page-header"},[_c('WidgetToolbar',{attrs:{"back":_vm.active_page == 'profiles',"title":"Matrix","icon":require('@/assets/admin-icon/menu/pie-chart-active.svg')},on:{"onBack":function($event){return _vm.backToSkills()}},scopedSlots:_vm._u([{key:"leftOptions",fn:function(){return [_c('widgetTabs',{attrs:{"tabs":[
                    {
                        title: 'General',
                        value: 'general',
                        icon: {
                            inactive: require('@/assets/matrix/general.svg'),
                            active: require('@/assets/matrix/general-active.svg')
                        }
                    },
                    {
                        title: 'Compare',
                        value: 'compare',
                        icon: {
                            inactive: require('@/assets/matrix/compare.svg'),
                            active: require('@/assets/matrix/compare-active.svg')
                        }
                    },
                ]},on:{"change":_vm.switchTab},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}})]},proxy:true}])},[_c('div',{staticClass:"options"})])],1),(_vm.active_page == 'general')?_c('SkillsChart',{on:{"ViewConsultantsProfiles":_vm.showConsultantsProfiles}}):_vm._e(),(_vm.active_page == 'compare')?_c('SkillsCompare'):_vm._e(),(_vm.active_page == 'profiles')?_c('ConsultantsProfiles',{attrs:{"form":_vm.formFilter}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }